<template>
  <div>
    <span v-if="isLightTheme" @click="toggleTheme">☀️</span>
    <span v-else @click="toggleTheme">🌙</span>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'ThemeToggler',
  computed: mapState(['isLightTheme']),
  methods: {
    setTheme: function(isLightTheme) {
      if (isLightTheme) {
        document.body.setAttribute('data-theme', 'light')
      } else {
        document.body.setAttribute('data-theme', 'dark')
      }
    },
    ...mapMutations(['toggleTheme', 'loadThemes'])
  },
  mounted: function() {
    this.loadThemes()
    this.setTheme(this.isLightTheme)
  },
  watch: {
    isLightTheme: function(val) {
      this.setTheme(val)
    }
  }
}
</script>

<style>
body[data-theme='dark'] {
  --font-color: white;
  --bg-color: black;
  --td-border-color: white;
  --tr-hover-color: #5f5f5f;
}
</style>

<style scoped>
div {
  position: relative;
  float: right;
}

span {
  cursor: pointer;
  user-select: none;
}
</style>
